import { useState } from "react";
import { createTranslator, getRuntimeLanguage } from "../i18n";

export const USER_RADIUS_KM_FALLBACK = 5;
export const MAP_DISCOVERY_RADIUS_KM_FALLBACK = 4;
export const LOCATION_DISCOVERY_RADIUS_MILES = 80;
export const LOCATION_DISCOVERY_RADIUS_KM = 128.75;

export const tabs = [
  { id: "map", label: "Mapa" },
  { id: "search", label: "Buscar" },
  { id: "list", label: "Lista" },
  { id: "ranking", label: "Ranking de lojas" },
  { id: "market", label: "Mercado" },
  { id: "settings", label: "Conta" },
];

export const surfaceStyle = {
  background: "rgba(255, 252, 248, 0.94)",
  borderRadius: 26,
  border: "1px solid rgba(251, 146, 60, 0.16)",
  boxShadow: "0 22px 60px rgba(124, 45, 18, 0.10)",
  backdropFilter: "blur(16px)",
};

export const cardStyle = {
  ...surfaceStyle,
  padding: 20,
};

export const inputStyle = {
  width: "100%",
  padding: "13px 15px",
  borderRadius: 16,
  border: "1px solid #fdba74",
  background: "#fffaf5",
  color: "#431407",
  outline: "none",
  boxSizing: "border-box",
};

export const primaryButtonStyle = {
  border: "none",
  borderRadius: 16,
  padding: "13px 18px",
  background: "linear-gradient(135deg, #ef4444 0%, #f97316 52%, #f59e0b 100%)",
  color: "#ffffff",
  cursor: "pointer",
  fontWeight: 700,
  boxShadow: "0 14px 32px rgba(234, 88, 12, 0.26)",
};

export const secondaryButtonStyle = {
  ...primaryButtonStyle,
  background: "#7c2d12",
  boxShadow: "0 14px 30px rgba(124, 45, 18, 0.22)",
};

export const ghostButtonStyle = {
  ...primaryButtonStyle,
  background: "#fff7ed",
  color: "#c2410c",
  boxShadow: "none",
  border: "1px solid #fdba74",
};

export function SectionTitle({ eyebrow, title, description, action }) {
  const [isHelpOpen, setIsHelpOpen] = useState(false);
  const translate = createTranslator(getRuntimeLanguage());
  const helpLabels = {
    title: translate("ui.help.title", "Sobre esta tela"),
    close: translate("common.close", "Fechar"),
  };

  return (
    <>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "flex-start",
          gap: 16,
          flexWrap: "wrap",
          marginBottom: 18,
        }}
      >
        <div>
          {eyebrow && (
            <div
              style={{
                marginBottom: 8,
                fontSize: 12,
                fontWeight: 800,
                letterSpacing: "0.08em",
                textTransform: "uppercase",
                color: "#ea580c",
              }}
            >
              {eyebrow}
            </div>
          )}
          <div style={{ display: "flex", alignItems: "center", gap: 10, flexWrap: "wrap" }}>
            <h2 style={{ margin: 0, fontSize: 26, lineHeight: 1.08 }}>{title}</h2>
            {description ? (
              <button
                type="button"
                onClick={() => setIsHelpOpen(true)}
                aria-label={helpLabels.title}
                title={helpLabels.title}
                style={{
                  width: 34,
                  height: 34,
                  borderRadius: 999,
                  border: "1px solid #fdba74",
                  background: "#fff7ed",
                  color: "#c2410c",
                  fontWeight: 800,
                  fontSize: 16,
                  cursor: "pointer",
                  boxShadow: "0 8px 18px rgba(249, 115, 22, 0.12)",
                }}
              >
                ?
              </button>
            ) : null}
          </div>
        </div>
        {action}
      </div>

      {description && isHelpOpen ? (
        <div
          role="dialog"
          aria-modal="true"
          aria-label={helpLabels.title}
          onClick={() => setIsHelpOpen(false)}
          style={{
            position: "fixed",
            inset: 0,
            background: "rgba(15, 23, 42, 0.38)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: 20,
            zIndex: 1000,
          }}
        >
          <div
            onClick={(event) => event.stopPropagation()}
            style={{
              width: "min(92vw, 420px)",
              borderRadius: 24,
              background: "#ffffff",
              border: "1px solid #fdba74",
              boxShadow: "0 24px 60px rgba(124, 45, 18, 0.16)",
              padding: 22,
            }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "flex-start",
                gap: 12,
                marginBottom: 14,
              }}
            >
              <strong style={{ fontSize: 18, lineHeight: 1.2 }}>{helpLabels.title}</strong>
              <button
                type="button"
                onClick={() => setIsHelpOpen(false)}
                style={{
                  width: 34,
                  height: 34,
                  borderRadius: 999,
                  border: "1px solid #e5e7eb",
                  background: "#f8fafc",
                  color: "#7c2d12",
                  fontWeight: 700,
                  cursor: "pointer",
                }}
              >
                x
              </button>
            </div>
            <div style={{ color: "#7c2d12", lineHeight: 1.6 }}>{description}</div>
            <button
              type="button"
              onClick={() => setIsHelpOpen(false)}
              style={{ ...primaryButtonStyle, width: "100%", marginTop: 18 }}
            >
              {helpLabels.close}
            </button>
          </div>
        </div>
      ) : null}
    </>
  );
}
